<div class="dialog-container">
  <h1 mat-dialog-title>
    Update {{ userData.first_name + ' ' + userData.last_name }}
  </h1>
  <form [formGroup]="userUpdateForm">
    <mat-tab-group (selectedTabChange)="handleTabChange($event)">
      <mat-tab label="Update Info">
        <mat-form-field appearance="fill" style="margin-top: 20px">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="first_name" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="last_name" />
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Role</mat-label>
          <mat-select
            formControlName="role_id"
            (valueChange)="handleRoleChange($event)"
          >
            @for (role of userRoles(); track role.id) {
              <mat-option [value]="role.id">{{ role.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" *ngIf="!adminRoleSelected">
          <mat-label>Permissions</mat-label>
          <mat-select formControlName="permissions" multiple>
            <mat-checkbox
              disableRipple
              [checked]="isAllSelected()"
              (change)="onCheckboxChange($event)"
              >Select All</mat-checkbox
            >
            @for (group of userPermissionsListGroups; track group) {
              <mat-optgroup [label]="group.module">
                @for (tool of group.tools; track tool.permission_id) {
                  <mat-option [value]="tool.name" style="padding-left: 30px"
                    >{{ tool.title }}
                    <mat-slide-toggle
                      *ngIf="shouldShowToggle(tool.name)"
                      [checked]="tool.active"
                      (click)="$event.stopPropagation()"
                      (change)="onToggleChange(tool)"
                    >
                    </mat-slide-toggle>
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Reset Password">
        <div class="password-error" *ngIf="showPasswordError">
          {{ passwordErrorMsg }}
        </div>
        <mat-form-field appearance="fill" style="margin-top: 20px">
          <mat-label>New Password</mat-label>
          <input type="password" formControlName="new_password" matInput />
          <mat-error *ngIf="userUpdateForm.controls['new_password'].invalid"
            >You must enter a value</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Confirm Password</mat-label>
          <input type="password" formControlName="password_confirm" matInput />
          <mat-error *ngIf="userUpdateForm.controls['password_confirm'].invalid"
            >You must enter a value</mat-error
          >
          <mat-error
            *ngIf="
              userUpdateForm.controls['password_confirm'].value !==
              userUpdateForm.controls['new_password'].value
            "
            >You must enter a value</mat-error
          >
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </form>

  <div mat-dialog-actions>
    <button mat-button (click)="onCancelClick()">Cancel</button>
    <button mat-button (click)="submit()" cdkFocusInitial>Update</button>
  </div>
</div>
